// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__news-ticker-container__kWx7r {
  overflow: hidden;
  width: 100%;
  background-color: #f1f1f1;
  padding: 10px 0;
  margin-top: -10px;
}
.index-module__news-ticker__ciNJO {
  display: flex;
  width: 100%;
}
.index-module__todays-notify__XnGJk {
  flex-shrink: 0;
  padding: 0 20px;
  font-size: 14px;
  color: red;
  font-weight: bold;
  white-space: nowrap;
}
.index-module__future-notify__Y6Q0o {
  flex-shrink: 0;
  padding: 0 20px;
  font-size: 14px;
  color: black;
  font-weight: normal;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/NewsSlider/index.module.less"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".news-ticker-container {\n  overflow: hidden;\n  width: 100%;\n  background-color: #f1f1f1;\n  padding: 10px 0;\n  margin-top: -10px;\n}\n.news-ticker {\n  display: flex;\n  width: 100%;\n}\n.todays-notify {\n  flex-shrink: 0;\n  padding: 0 20px;\n  font-size: 14px;\n  color: red;\n  font-weight: bold;\n  white-space: nowrap;\n}\n.future-notify {\n  flex-shrink: 0;\n  padding: 0 20px;\n  font-size: 14px;\n  color: black;\n  font-weight: normal;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"news-ticker-container": `index-module__news-ticker-container__kWx7r`,
	"news-ticker": `index-module__news-ticker__ciNJO`,
	"todays-notify": `index-module__todays-notify__XnGJk`,
	"future-notify": `index-module__future-notify__Y6Q0o`
};
export default ___CSS_LOADER_EXPORT___;
